import { render, staticRenderFns } from "./CreateTaskInstance.vue?vue&type=template&id=cc8479e6&scoped=true&"
import script from "./CreateTaskInstance.vue?vue&type=script&lang=js&"
export * from "./CreateTaskInstance.vue?vue&type=script&lang=js&"
import style0 from "./CreateTaskInstance.vue?vue&type=style&index=0&id=cc8479e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8479e6",
  null
  
)

export default component.exports